'use strict';
var once = require('lodash.once');

var redirect = once(function (window, location) {
    window.location.href = location;
});

module.exports = redirect;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/redirect.js
 ** module id = 14
 ** module chunks = 0
 **/